import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    templateUrl: './notFound.component.html',
    standalone: false
})
export class NotFoundComponent  {

  constructor(private _router: Router) {
  }

}
